import { render, staticRenderFns } from "./ResourceAlertsForm.vue?vue&type=template&id=a7d84fd4"
import script from "./ResourceAlertsForm.vue?vue&type=script&lang=js"
export * from "./ResourceAlertsForm.vue?vue&type=script&lang=js"
import style0 from "./ResourceAlertsForm.vue?vue&type=style&index=0&id=a7d84fd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports